import { makeActionCreator } from '../../config/store/utils'
import { getDownloadFrameworks } from '../../services/downloads'

export const GET_ENTITY_REPORT_OPTIONS = 'GET_ENTITY_REPORT_OPTIONS'
export const GET_ENTITY_REPORT_OPTIONS_ERROR = 'GET_ENTITY_REPORT_OPTIONS_ERROR'
export const GET_ENTITY_REPORT_OPTIONS_SUCCESS = 'GET_ENTITY_REPORT_OPTIONS_SUCCESS'
export const onGetEntityReportOptions = makeActionCreator(GET_ENTITY_REPORT_OPTIONS)
export const onGetEntityReportOptionsError = makeActionCreator(GET_ENTITY_REPORT_OPTIONS_ERROR, 'payload')
export const onGetEntityReportOptionsSuccess = makeActionCreator(GET_ENTITY_REPORT_OPTIONS_SUCCESS, 'payload')
export const onGetEntityReportOptionsThunk = () => async dispatch => {
  dispatch(onGetEntityReportOptions())

  try {
    const { data } = await getDownloadFrameworks()
    const biddingOptions = data?.payload[0]?.data?.map(item => ({
      name: item.name,
      value: item.id
    }))
    return dispatch(onGetEntityReportOptionsSuccess({ biddingOptions }))
  } catch (error) {
    return dispatch(onGetEntityReportOptionsError({ error }))
  }
}
